import { Box, Divider, List as MUIList, Skeleton } from '@mui/material';
import { Occasion, Player, PlayerData } from '@oskarjiang/matchi-types';
import { ListItem } from './ListItem';
import { baseUrl } from '../../constants/endpoints';
import { useQuery } from '@tanstack/react-query';
import { useFocusedOccasion } from '../../contexts/FocusedOccasionContext';
import React from 'react';

export const List = () => {
	const { focusedOccasion } = useFocusedOccasion();
	const { data, isLoading } = useQuery<Occasion>({
		queryKey: ['participants', focusedOccasion?.id],
		queryFn: () => fetch(`${baseUrl}/occasion/${focusedOccasion?.id}`).then((res) => res.json()),
	});

	const { data: playerData, isLoading: isLoadingPlayerData } = useQuery<PlayerData[]>({
		queryKey: ['player-data'],
		queryFn: () => fetch(`${baseUrl}/playerData`).then((res) => res.json()),
		staleTime: 7 * 24 * 60 * 60 * 1000, // 1 week - rarely changes
	});
	return (
		<MUIList component="nav">
			{!isLoading ? (
				data?.occasionParticipants
					.sort((a: Player, b: Player) => {
						const levelA = playerData?.find((player) => player.player.userId === a.userId)?.averageLevel;
						const levelB = playerData?.find((player) => player.player.userId === b.userId)?.averageLevel;
						if (levelA === undefined || levelA === null) {
							return 1;
						}
						if (levelB === undefined || levelB === null) {
							return -1;
						}
						return levelB - levelA;
					})
					.map((participant: Player, index: number) => (
						<React.Fragment key={participant.userId}>
							<ListItem
								participant={participant}
								averageLevel={playerData?.find((player) => player.player.userId === participant.userId)?.averageLevel ?? undefined}
								isLoading={isLoadingPlayerData}
							/>
							{(index + 1) % 4 === 0 ? (
								<Divider
									component="li"
									flexItem
									sx={{
										borderBottomWidth: 2,
										borderColor: 'primary.main',
										fontWeight: 700,
										color: 'text.secondary',
										px: 1,
									}}
								>
									{index + 1}
								</Divider>
							) : null}
						</React.Fragment>
					))
			) : (
				<>
					<Box sx={{ m: 0.5 }}>
						<Skeleton variant="rounded" width="100%" height={72} />
					</Box>
					<Box sx={{ m: 0.5 }}>
						<Skeleton variant="rounded" width="100%" height={72} />
					</Box>
					<Box sx={{ m: 0.5 }}>
						<Skeleton variant="rounded" width="100%" height={72} />
					</Box>
				</>
			)}
		</MUIList>
	);
};
